export default __webpack_public_path__ + "static/media/main.fe673042.jpg";